import { MCPServer, MCPTool, MCPServerConfig } from '@/shared/types';
import { api } from './api';

// Use the centralized API endpoints from config
import { API_ENDPOINTS } from '../../shared/config';

export const mcpApi = {
  /**
   * Get all MCP servers
   */
  getServers: () => api.get(API_ENDPOINTS.mcpServers),

  /**
   * Get a specific MCP server
   */
  getServer: (serverId: string) => api.get(`${API_ENDPOINTS.mcpServers}/${serverId}`),

  /**
   * Create a new MCP server
   */
  createServer: (server: Omit<MCPServer, 'id' | 'createdAt' | 'updatedAt'>) =>
    api.post(API_ENDPOINTS.mcpServers, server),

  /**
   * Update an MCP server
   */
  updateServer: (serverId: string, server: Partial<MCPServer>) =>
    api.put(`${API_ENDPOINTS.mcpServers}/${serverId}`, server),

  /**
   * Delete an MCP server
   */
  deleteServer: (serverId: string) => api.delete(`${API_ENDPOINTS.mcpServers}/${serverId}`),

  /**
   * Test connection to an MCP server
   */
  testConnection: (serverId: string) => api.post(API_ENDPOINTS.testMCPConnection(serverId)),

  /**
   * Toggle server enabled/disabled
   */
  toggleServer: (serverId: string) => api.post(API_ENDPOINTS.toggleMCPServer(serverId)),

  /**
   * Get all MCP tools
   */
  getTools: () => api.get(API_ENDPOINTS.mcpTools),

  /**
   * Get tools for a specific server
   */
  getServerTools: (serverId: string) => api.get(`${API_ENDPOINTS.mcpServers}/${serverId}/tools`),

  /**
   * Toggle tool enabled/disabled
   */
  toggleTool: (toolId: string) => api.post(API_ENDPOINTS.toggleMCPTool(toolId)),

  /**
   * Get MCP configuration
   */
  getConfig: () => api.get(API_ENDPOINTS.mcpConfig),

  /**
   * Update MCP configuration
   */
  updateConfig: (config: Partial<MCPServerConfig>) =>
    api.put(API_ENDPOINTS.mcpConfig, config),

  /**
   * Discover available MCP servers
   */
  discoverServers: (url: string) => api.post(`${API_ENDPOINTS.mcpServers}/discover`, { url }),

  /**
   * Get server capabilities
   */
  getServerCapabilities: (serverId: string) =>
    api.get(`${API_ENDPOINTS.mcpServers}/${serverId}/capabilities`),

  /**
   * Execute a tool
   */
  executeTool: (serverId: string, toolName: string, parameters: Record<string, any>) =>
    api.post(`${API_ENDPOINTS.mcpServers}/${serverId}/tools/${toolName}/execute`, { parameters }),
};
